<template>
    <span class="text-nowrap">
        <template>
            <router-link :class="classList" :to="{'name': detailPath, 'params': {'id': prescriptionId}}">{{statusId === 998? 'Pay Now': 'View Prescription'}}</router-link>
        </template>
    </span>
</template>

<script>
export default {
    'name': 'UserPrescriptionAction',
    'props': {
        'statusId': {
            'required': true
        },
        'prescriptionId': {
            'required': true
        },
        'detailPath': {
            'required': true
        },
        'classList': {
            'type': Array
        }
    }
};
</script>

<style>

</style>
